import {ActionCreator, createAction} from '@packages/utilities/create-action';
import {
  CANVAS_BODY_RENDERED,
  CANVAS_WIDTH_SET,
  EXTERNAL_CUSTOM_CODE_LOADED,
} from '@packages/systems/designer/actions';
import {WebflowCssProperty} from '@packages/systems/core/utils/WebflowCssSubset';
import {CodeBlock} from '@packages/systems/customCode/ui';

export {
  getNodeClickedActionCreator,
  getNodeClickedActionCreatorFromState,
} from './nodeClicked';

export type {
  NodeClickedPayload,
  CodeIslandMouseEvent,
} from './nodeClicked/types';

export {
  getNodeHoveredActionCreator,
  getNodeHoveredActionCreatorFromState,
} from './nodeHovered';

export type {NodeHoveredPayload} from './nodeHovered/types';

export const canvasBodyRendered: ActionCreator<
  typeof CANVAS_BODY_RENDERED,
  {
    computedStyle?: Partial<Record<WebflowCssProperty, string>>;
    selectedNodeIdStylesChanged?: boolean;
  }
> = createAction(CANVAS_BODY_RENDERED);

export const externalCustomCodeLoaded: ActionCreator<
  typeof EXTERNAL_CUSTOM_CODE_LOADED,
  CodeBlock[]
> = createAction(EXTERNAL_CUSTOM_CODE_LOADED);

export const setCanvasWidth: ActionCreator<typeof CANVAS_WIDTH_SET, number> =
  createAction(CANVAS_WIDTH_SET);
